import showdown from 'showdown';

/**
 * Create a configured showdown markdown-to-HTML converter.
 *
 * @method getMarkdownConverter
 * @return {showdown.Converter} A converter with tables and strikethrough enabled.
 */
export const getMarkdownConverter = () => {
    return new showdown.Converter({
        tables: true,
        strikethrough: true,
    });
};
